import { createSlice } from '@reduxjs/toolkit';
import { defaultAccountNoteSlice } from '@/redux/modules/billingManagement/accountNote/accountNote.types';
import { saveAccountNote } from '@/redux/modules/billingManagement/accountNote/accountNote.actions';

const accountNoteSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(saveAccountNote.pending, (slice) => {
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(saveAccountNote.fulfilled, (slice) => {
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(saveAccountNote.rejected, (slice) => {
            slice.wasSaveSuccessful = false;
        });
    },
    initialState: defaultAccountNoteSlice,
    name: 'accountNote',
    reducers: {},
});

export const { reducer: accountNoteReducer } = accountNoteSlice;
